import { h, Component } from 'preact';
import { MkComponent } from 'lib/mkjs/mkcomponent';
import ContactEntity from "entities/contactentity";
import ContactInfo from "entities/contactinfo";
import Connection from "entities/connection";

export default class ConnectionRequest extends MkComponent {

	getFieldComponent(fieldName, item) {
		const fieldComponents = {
			requestor: this._fieldReference(ContactEntity),
			requestee: this._fieldReference(ContactEntity),
			personalContactCausingRequest: this._fieldReference(ContactInfo),
			resultConnection: this._fieldReference(Connection)
		}
		return fieldComponents[fieldName];
	}
}



// WEBPACK FOOTER //
// ./entities/connectionrequest/index.js